//订单必填校验
/**
 * @param list {Array} 外部传入字段列表
 * @param result {Object} 校验结果 {pass: '',resultList: [],noPassList: [],messsage:''}
 * {
 *  pass {Boolean} 是否校验通过
 *  resultList {Array} 原数组 包含每个样本组未填写的必填项 noPassList
 *  noPassList {Array} 所有样本组未填写的必填项数据
 *  messsage {String} 返回的信息
 * }
 * 
 */
export function requiredVerification(list) {
    let verifList = []
    if (list) {
        verifList = JSON.parse(JSON.stringify(list))
    }
    //提取出所有样本的字段列表
    let fieldList = verifList.map(item => item.fieIdList);
    //
    //取出未隐藏且为必填的字段
    let resultList = fieldList.map(item =>
        item.filter(items => !items.hide && items.isRequired === 1)
    );
    resultList.map((item, index) => {
        item.sampleName = verifList[index].sampleName
    })
    let allNoPassList = []
    let noPassNum = 0

    resultList.forEach(item => {
        item.forEach(items => {
            items.noPassList = [];
            if([11, 13].includes(item.fieIdType)) return
            if(items.fieIdType === 12 && items.fieldGroupId && items.fieldGroupValues){
                items.fieldGroupValues.map(itemx => {
                    if(itemx.isRequired != 1 || [2, 10, 11, 12, 13].includes(itemx.fieIdType)) return
                    const boolean_number = [6].includes(itemx.fieIdType) && (itemx.fieIdValue == undefined || itemx.fieIdValue == null)
                    const boolean_range = [9].includes(itemx.fieIdType) && (itemx.fieIdValue == undefined || itemx.fieIdValue == null || itemx.fieldValueRange == undefined || itemx.fieldValueRange == null || (itemx.fieIdValue == itemx.fieldValueRange))
                    const boolean_other = ![6, 9].includes(itemx.fieIdType) && !itemx.fieIdValue
                    if(boolean_number || boolean_range || boolean_other) {
                        noPassNum++;
                        itemx.sampleName = item.sampleName
                        items.noPassList.push(itemx);
                        allNoPassList.push(itemx)
                    }
                })
            }
            if(items.isRequired === 1 && items.fieIdType != 12){
                const boolean_number = [6].includes(items.fieIdType) && (items.fieIdValue == undefined || items.fieIdValue == null)
                const boolean_range = [9].includes(items.fieIdType) && (items.fieIdValue == undefined || items.fieIdValue == null || items.fieldValueRange == undefined || items.fieldValueRange == null || (items.fieIdValue == items.fieldValueRange))
                const boolean_other = ![6, 9].includes(items.fieIdType) && !items.fieIdValue
                if(boolean_number || boolean_range || boolean_other) {
                    noPassNum++
                    items.sampleName = item.sampleName
                    items.noPassList.push(items)
                    allNoPassList.push(items)
                }
            }
        });
    });
    let result = {
        pass: true,
        noPassList: [],
        resultList,
        messsage: ''
    }
    if (noPassNum > 0) {
        result.pass = false
        result.noPassList = allNoPassList
        if (allNoPassList[0].sampleName != '全局问题') {
            result.messsage = allNoPassList[0].sampleName + '组样品-' + allNoPassList[0].fieIdName + '填写不规范'
        } else {
            result.messsage = '全局问题' + allNoPassList[0].fieIdName + '填写不规范'
        }
    }
    return result
}

//设备预约字段处理
/**
 * list {Array} 外部传入的字段类表
 * fieIdId {Number} 字段id
 * fieIdName {String} 字段名称
 * fieIdType {Number} 字段类型 1 单选 2多选 3 单行文本 4 多行文本 5 富文本 6 整数 7 浮点 8 上传附件 9 数字范围 10 
 * isRequired {Number} 是否必填 1是0否
 * noCheck {String} 不可检测元素
 * elementPrice {Number} 元素价格（单个）
 * isRelevance {Number} 字段是否关联 1是0否
 * relevanceField {Number} 关联字段id
 * relevanceOptionId {Number} 关联选项id
 * fileList {Arrar{Object}} 文件list {name: '',url:''}
 */

export function FieldProcessing(list) {
    //有关联id的初始化需要被隐藏
    list.map(item => {
        // item.fieIdValue = ''
        if (item.isRelevance) {
            item.hide = true
        } else {
            item.hide = false
        }
    })
    return list
}

// //根据传入的字段 对预约表单进行处理
// export function FieldScreen(Selected, data) {
//     data.fieIdList.forEach((item, index) => {
//         //找出操作的字段 然后更新选项和字段值
//         if (item.fieIdId === Selected.fieIdId) {
//             item.options = Selected.options;
//             item.fieIdValue = Selected.fieIdValue;
//             item.valueId = Selected.optionId;
//         }
//         //如果存在关联id为本次操作字段的字段id且该字段关联值为1时
//         //进行关联选项值判断 判断操作字段的选项值是否包含关联对线的关联选项值
//         if (item.relevanceField === Selected.fieIdId && item.isRelevance) {
//             //将该字段对象的关联选项id转换成数据 且元素为数字
//             const relevanceOptionIdList = item.relevanceOptionId.split(',').map(str => parseInt(str));
//             // 查找操作字段选中选项是否包含该对象的关联选项id
//             const containsElements = Selected.optionId.some(e => relevanceOptionIdList.includes(e));
//             //如果有 则不隐藏该字段（hide为false） 如果没有 则继续隐藏（hide为true）
// 			item.hide = !containsElements;
// 			if (item.fieIdType == 1 || item.fieIdType == 2) {
// 				item.fieIdValue = []
// 				item.valueId = []
// 			} else { 
// 				item.fieIdValue = ''
// 				item.valueId = ''
// 			}

//         }
//     });
//     return data;

// }
//单选多选组件切换，根据传入的字段 对预约表单进行处理
export function FieldScreen(Selected, data, flag) {
    /**
     * @param list {Array} 外部传入的样品列表
     * @param fieIdId {Number} 字段id
     * @param fieIdName {String} 字段名称
     * @param fieIdType {Number} 字段类型 1 单选 2多选 3 单行文本 4 多行文本 5 富文本(小程序处理为多行输入框)  6 整数 7 浮点 8 上传附件 9 数字范围 10 
     * @param isRequired {Number} 是否必填 1是0否
     * @param noCheck {String} 不可检测元素
     * @param elementPrice {Number} 元素价格（单个）
     * @param isRelevance {Number} 字段是否关联 1是0否
     * @param relevanceField {Number} 关联字段id
     * @param relevanceOptionId {Number} 关联选项id
     * @param fileList {Arrar{Object}} 文件list {name: '',url:''}
     */
    data.fieIdList.forEach((item, index) => {
        //找出操作的字段 然后更新选项和字段值
        if (!flag) {
            if (item.fieIdId === Selected.fieIdId) {
                item.options = Selected.options;
                item.fieIdValue = Selected.fieIdValue;
                item.optionId = Selected.optionId
                item.valueId = Selected.optionId.join(',')
            }
        } else {
            if (item.fieIdId === Selected.fieIdId) {
                item.optionIds = Selected.optionIds
                item.optionId = null
            }
        }
        if (item.hide == false) {
            //如果他为显示状态就要去查询是否有有与他处于关联状态的
            let flags = false
            data.fieIdList.forEach(itemx => {
                if (item.relevanceField == itemx.fieIdId) {
                    if (itemx.hide) {
                        item.hide = true
                        item.optionId = null
                    }
                }
            })
        }
        //如果存在关联id为本次操作字段的字段id且该字段关联值为1时
        //进行关联选项值判断 判断操作字段的选项值是否包含关联对线的关联选项值
        if (item.relevanceField === Selected.fieIdId && item.isRelevance) {
            //将该字段对象的关联选项id转换成数据 且元素为数字
            let relevanceOptionIdList = item.relevanceOptionId.split(',').map(str => parseInt(str));
            // 查找操作字段选中选项是否包含该对象的关联选项id
            let containsElements = ''
            if (flag) {
                containsElements = Selected.optionIds.some(e => relevanceOptionIdList.includes(e));
            } else {
                containsElements = Selected.optionId.some(e => relevanceOptionIdList.includes(e));
            }
            // let containsElements = Selected.optionId.some(e => relevanceOptionIdList.includes(e));
            //如果有 则不隐藏该字段（hide为false） 如果没有 则继续隐藏（hide为true）
            // item.hide = !containsElements;
            if (flag) {
                item.hide = true
            } else {
                item.hide = !containsElements;
            }
            if (containsElements) {
                if (item.options && item.options.length > 0) {
                    item.options.map(items => {
                        items.isActive = false
                    })
                    item.optionIds = item.options.map(items => items.optionId)
                    FieldScreen(item, data, true)
                }

            }

        }
    });
    return data;

}

//输入框赋值
export function inputFieIdValue(Selected, data) {
    //使用find方法来查找符合条件的项
    const itemToUpdate = data.fieIdList.find(item => item.fieIdId === Selected.fieIdId);

    if (itemToUpdate) {
        // 更新该项的属性
        itemToUpdate.fieIdValue = Selected.fieIdValue;
    }

    return data;
}